import { render, staticRenderFns } from "./DepositUsd.vue?vue&type=template&id=56a4428f&scoped=true"
import script from "./DepositUsd.vue?vue&type=script&lang=js"
export * from "./DepositUsd.vue?vue&type=script&lang=js"
import style0 from "./DepositUsd.vue?vue&type=style&index=0&id=56a4428f&prod&lang=scss&scoped=true"
import style1 from "./DepositUsd.vue?vue&type=style&index=1&id=56a4428f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4428f",
  null
  
)

export default component.exports